(() => {
  const product = document.querySelector('.product[data-product-template="supa-resistance-bands-v1"]');
  const bar = document.querySelector('[data-hpg-mobile-purchase-bar]');
  if (!product || !bar) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const included = document.querySelector('[data-hpg-whats-included]');
  // Fixed UI must live outside product sections that animate with transforms.
  document.body.append(bar);
  let frame = 0;
  let popupHost;
  let popupRoot;

  function positionPopup() {
    const shadow = popupHost?.shadowRoot;
    if (!shadow || shadow === popupRoot) return;
    popupRoot = shadow;
    // Pop Convert's proof container lives in its open shadow root. Document
    // styles cannot reach it; the measured bar height inherits through the host.
    const style = document.createElement('style');
    style.textContent = `@media (max-width: 749px) {
      .proof-container.bottom {
        bottom: calc(1em + var(--hpg-mobile-purchase-height, 0px) + 8px) !important;
      }
    }`;
    shadow.append(style);
  }

  function syncSummary() {
    const selectedSet = product.querySelector('variant-selects fieldset input:checked');
    const name = bar.querySelector('[data-hpg-sticky-set-name]');
    const brand = selectedSet?.nextElementSibling?.querySelector('.variant-brand')?.textContent.trim();
    const title = brand ? `${brand} Bands Set` : name.textContent;
    if (name.textContent !== title) name.textContent = title;

    const price = product.querySelector('.main-product-price .price');
    const onSale = price?.classList.contains('price--on-sale');
    const current = price?.querySelector(onSale ? '.price-item--sale' : '.price__regular .price-item--regular');
    const compare = onSale ? price.querySelector('.price__sale .price-item--regular') : null;
    for (const [selector, source] of [['[data-hpg-sticky-price]', current], ['[data-hpg-sticky-compare]', compare]]) {
      const target = bar.querySelector(selector);
      const text = source?.textContent.trim() || '';
      if (target.textContent !== text) target.textContent = text;
      target.hidden = !text;
    }
  }

  function update() {
    frame = 0;
    syncSummary();
    const submit = product.querySelector('.product-form__submit');
    const dialogOpen = [...document.querySelectorAll('cart-drawer.active, cart-drawer[open], lb-upsell-addon-popup .lb-addon-popup-container, dialog[open]')].some((element) => {
      const styles = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
    });
    const visible = mobile.matches && submit?.getBoundingClientRect().bottom <= 0 && !dialogOpen;
    bar.hidden = !visible;
    root.style.setProperty('--hpg-mobile-purchase-height', `${visible ? bar.getBoundingClientRect().height : 0}px`);
    const viewportBottom = window.visualViewport
      ? window.visualViewport.offsetTop + window.visualViewport.height
      : window.innerHeight;
    root.classList.toggle('hpg-popconvert-eligible', Boolean(mobile.matches && included && included.getBoundingClientRect().top < viewportBottom && !dialogOpen));

    popupHost = document.getElementById('pop-convert-app');
    positionPopup();
  }

  function requestUpdate() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  bar.querySelector('[data-hpg-return-to-options]').addEventListener('click', () => {
    const submit = product.querySelector('.product-form__submit');
    if (!submit) return;
    const viewportBottom = window.visualViewport
      ? window.visualViewport.offsetTop + window.visualViewport.height
      : window.innerHeight;
    // Leave the main purchase button visible above mobile browser controls.
    const top = Math.max(0, window.scrollY + submit.getBoundingClientRect().bottom - viewportBottom + 24);
    window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  product.addEventListener('change', requestUpdate);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.visualViewport?.addEventListener('resize', requestUpdate);
  mobile.addEventListener('change', requestUpdate);
  new ResizeObserver(requestUpdate).observe(bar);
  // App hosts and drawers can be inserted or toggled after initial load.
  new MutationObserver(requestUpdate).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
  update();
})();
